import PatientControl from '../PatientComponent/PatientControl';

const DoctorControl = () => {

    return (
        <PatientControl />
    );
};

export default DoctorControl;
